import Radio from 'backbone.radio';
import AddCollaboratorDialog from '@/views/dialogs/add_collaborator';

    var globalCh = Radio.channel('global');
    var apiCh = Radio.channel('api');
    /**
     * Show a dialog to grant roles to an account.
     * @params account, the grantor
     */
    export default function show_add_collaborator_dialog(account, options) {
        // Get the account roles collection
        let role_collection = apiCh.request('account_role');
        var accounts = apiCh.request('account');
        var grants = apiCh.request('grant');
        let grants_count = 0;
        grants.each(function(grant){
            if (grant.rel.get('target') && grant.rel.get('target').id === account.id) {
                grants_count++;
            }
        });
        if (!role_collection) return;

        if (!role_collection.length) role_collection.fetch();

        // If they can't grant anymore grants, don't open the dialog
        var max_collab = account.get('max_collaborators');
        if (max_collab >= 0 && max_collab <= grants_count) {
            return Radio.request('alerts', 'showAlert', {
                message: "This account can have at most " + max_collab + " collaborators at a time. Please delete a collaborator to add another.",
                messageType: 'danger',
                timeout: 5000
            });
        }

        // Only allow this collection to contain things the roles the target account can actually 
        // grant to the grantee
        // WEB-1883
        if (account.get('tier') === 'developer') {
            role_collection = role_collection.get_developer_tier_roles();
        } else if (account.get('tier') === 'evaluation') {
            role_collection = role_collection.get_evaluation_tier_roles();
        }

        var view = new AddCollaboratorDialog({
            roles: role_collection,
            model: account,
            accounts: accounts,
            success: (options && options.success)
        });
        globalCh.request('showDialog', view);
    }

